import { contactUpdateApi } from "../../api/contact/contactUpdateApi"

type PayloadShape = Parameters<typeof contactUpdateApi>[0]

export async function contactUpdateService(payload: PayloadShape, token: string) {
	return await contactUpdateApi(payload, token)
}
